import React, { useRef } from 'react';
import { Layout, Tabs } from 'tea-component';

import { useIntl } from 'umi';
import '@op/assets/scss/pages/gamestore/index.scss';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import GameStorePoint from '@op/operationLog/pages/gameStore';
import ContentBody from '@op/components/ContentBody';
import CriticSites from '../components/CriticSites';
import XboxStore from '../components/Xbox';
import useGameStoreTabs from '../hooks/useGameStoreTabs';
import PlaystationStore from '../components/Playstation';
import CardLoading from '@op/components/CardLoading';
import CardCommon from '@op/components/CardCommon';
// 过滤器
const { Content } = Layout;

export default function GameStore({ gameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: GameStorePoint });
  const scrollBody = useRef(null);
  const { formatMessage } = useIntl();
  const { tabs, tab, onActive, relative, relativePlatform, loading } =
    useGameStoreTabs({
      gameInfo,
    });

  const getRenderElement = () => {
    switch (tab) {
      case 'opencritic-metacritic':
        return (
          <CriticSites
            scrollBody={scrollBody}
            gameInfo={gameInfo}
            relativeInfo={relative}
          ></CriticSites>
        );
      case 'playstation':
        return (
          <PlaystationStore
            scrollBody={scrollBody}
            gameInfo={gameInfo}
          ></PlaystationStore>
        );
      default:
        return (
          <XboxStore scrollBody={scrollBody} gameInfo={gameInfo} channel={tab}></XboxStore>
        );
    }
  };

  return (
    <Content className="dbo-page dbo-gamestore" ref={scrollBody}>
      <Content.Header
        title={formatMessage({ id: 'Game Store' })}
        className="dbo-header contentHead-normal"
      >
        <div className="header-tab">
          <Tabs
            ceiling
            tabs={tabs}
            animated={false}
            activeId={tab}
            onActive={(tab) => onActive(tab)}
          />
        </div>
      </Content.Header>
      <ContentBody>
        <CardLoading loading={loading}>{getRenderElement()}</CardLoading>
        <>
          {loading && (
            <CardCommon
              className="dbo-gamestore-whole-screen-loading"
              loading={true}
            ></CardCommon>
          )}
        </>
      </ContentBody>
    </Content>
  );
}
